export default __webpack_public_path__ + "static/media/My wild side.8757af39.mp4";